import * as React from 'react';
import { Alert } from 'reactstrap';
import FAIcon from '../fAIcon/FAIcon';
import './CPItemWarning.css';

interface Props {
    errorMessage: string;
}

export const CPItemWarning: React.SFC<Props> = props => {
    return (
        <Alert style={{ float: 'none' }} color="danger" className="cpitemwarning">
            <FAIcon icon="exclamation-triangle" />
            {props.errorMessage}
        </Alert>
    );
};



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPItemWarning.tsx